import { render, staticRenderFns } from "./BasicInsertData.vue?vue&type=template&id=5f502ba5&scoped=true&"
import script from "./BasicInsertData.vue?vue&type=script&lang=js&"
export * from "./BasicInsertData.vue?vue&type=script&lang=js&"
import style0 from "./BasicInsertData.vue?vue&type=style&index=0&id=5f502ba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f502ba5",
  null
  
)

export default component.exports